import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import StandardButton from "../../../components/standardButton"; 

export default function DeleteTagsAdmin({
  open,
  handleClose,
  id,
  email, // Puoi rinominare in `label` se preferisci chiarezza semantica
  handleConfirm,
  title,
  message,
}) {
  const [confirmationText, setConfirmationText] = useState("");
  const [error, setError] = useState("");

  const handleChange = (event) => {
    setConfirmationText(event.target.value);
    setError("");
  };

  const isConfirmDisabled = confirmationText !== "DELETE";

  const handleConfirmClick = () => {
    if (isConfirmDisabled) {
      setError("You must type DELETE to proceed.");
      return;
    }
    handleConfirm(id);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
    >
      <DialogTitle
        id="confirm-dialog-title"
        sx={{
          backgroundColor: "#191919",
          fontFamily: "Urbanist, sans-serif",
        }}
      >
        {title}
      </DialogTitle>

      <DialogContent
        sx={{
          backgroundColor: "#191919",
          fontFamily: "Urbanist, sans-serif",
        }}
      >
        <DialogContentText
          id="confirm-dialog-description"
          sx={{
            color: "white",
            fontFamily: "Urbanist, sans-serif",
          }}
        >
          {message}
        </DialogContentText>

        <TextField
          fullWidth
          variant="outlined"
          placeholder='Type "DELETE" to confirm'
          value={confirmationText}
          onChange={handleChange}
          sx={{
            backgroundColor: "#fff",
            borderRadius: "5px",
            marginTop: "16px",
            input: { color: "#000", textAlign: "center", fontWeight: "bold" },
          }}
          error={!!error}
          helperText={error}
        />
      </DialogContent>

      <DialogActions
        sx={{
          backgroundColor: "#191919",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <StandardButton
          onClick={handleClose}
          type={"error"}
          variant={"outlined"}
          text={"Cancel"}
        />
        <StandardButton
          onClick={handleConfirmClick}
          text={"Confirm"}
          type={"error"}
          variant={"error"}
          disabled={isConfirmDisabled}
        />
      </DialogActions>
    </Dialog>
  );
}
